import React, { useEffect, useState } from "react";
import api, { money } from "../../lib/api";
import { AdminHeader } from "./AdminLayout";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);
  useEffect(() => { api.get("/admin/customers").then(r => setCustomers(r.data)); }, []);
  return (
    <div>
      <AdminHeader title="Customers" subtitle={`${customers.length} customers`} />
      <div className="bg-white border border-sage/30 rounded-sm overflow-x-auto">
        <table className="w-full text-sm min-w-[640px]">
          <thead><tr className="border-b border-sage/30 text-left text-forest/50 text-xs uppercase"><th className="p-3">Name</th><th className="p-3">Email</th><th className="p-3">Phone</th><th className="p-3">Orders</th><th className="p-3">Spent</th><th className="p-3">Last Order</th></tr></thead>
          <tbody>
            {customers.map((c) => (
              <tr key={c.id} className="border-b border-sage/15">
                <td className="p-3 font-medium">{c.name}</td><td className="p-3 text-forest/60">{c.email}</td><td className="p-3">{c.phone || "—"}</td>
                <td className="p-3">{c.order_count}</td><td className="p-3">{money(c.total_spent)}</td>
                <td className="p-3 text-forest/50">{c.last_order ? new Date(c.last_order).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
